module.exports = __webpack_public_path__ + "assets/img/SK.2ba0fc3f.svg";